import { render, staticRenderFns } from "./InquiryMerchant.vue?vue&type=template&id=a4ada9ac&scoped=true"
import script from "./InquiryMerchant.vue?vue&type=script&lang=js"
export * from "./InquiryMerchant.vue?vue&type=script&lang=js"
import style0 from "./InquiryMerchant.vue?vue&type=style&index=0&id=a4ada9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ada9ac",
  null
  
)

export default component.exports